module.exports = __webpack_public_path__ + "static/media/Sun-16.37126164.png";